import { useIsSemiLarge } from '@perpay-web/hooks/useIsSemiLarge';

import Toast from './Toast';
import styles from './Toast.scss';
import { useToastContext } from './useToastContext';

/**
 * Renders a stack of toasts.
 *
 * @returns {JSX.Element}
 */
export const ToastContainer = () => {
    // eslint-disable-next-line @perpay-web/container-component-hook-whitelist
    const { isSemiLarge } = useIsSemiLarge();

    const { toasts, removeToast, positionBottom, positionBottomDesktop } =
        useToastContext();

    return (
        <div
            className={styles['toast-container']}
            style={{
                bottom: `${isSemiLarge ? positionBottomDesktop : positionBottom}px`,
            }}
            role='status'
            aria-live='polite'
        >
            {toasts.map((toast) => (
                <Toast key={toast.id} toast={toast} onRemove={removeToast} />
            ))}
        </div>
    );
};
